// Select environment at build/run time via REACT_APP_ENV: 'BE' | 'LUX' | 'LOCAL'
// Default: 'BE'
const ENV = (process.env.REACT_APP_ENV || 'LOCAL').toUpperCase();

const URLS = {
    BE: 'https://beecleanapi.azurewebsites.net/api/',
    LUX: 'https://beecleanapi-net8.azurewebsites.net/api/',
    LOCAL: 'https://localhost:7017/api/',
};

export const API_URL = URLS[ENV] || URLS.BE;

// Auth API, en local on doit récupérer un token sur un env de prod:
// - In LOCAL, default to BE auth unless overridden later
// - In BE/LUX, same as API_URL
export const AUTH_API_URL = ENV === 'LOCAL' ? URLS.BE : API_URL;

export default { API_URL, AUTH_API_URL };
